import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  inject,
  Input,
  OnInit,
  Optional,
  Output,
  ViewChild
} from "@angular/core";
import {
  CodiceFiscaleHelperData,
  CodiceFiscaleService,
  CodiceFiscaleResult
} from "src/app/services/codice-fiscale.service";
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import { dateUtil } from "src/app/support/date-util";
import { DxFormComponent } from "devextreme-angular";
import { PopupComponent } from "src/app/services/popup/popup-component";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { clone } from "lodash-es";
import { POPUP_INJECT, PopupRef } from "src/app/services/popup/popup-ref";

@Component({
  selector: "snt-fiscal-code-helper",
  templateUrl: "fiscal-code-helper.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class FiscalCodeHelperComponent implements OnInit, PopupComponent {
  @ViewChild("formCodiceFiscaleHelper")
  dxForm!: DxFormComponent;

  @Output()
  result: EventEmitter<CodiceFiscaleResult> =
    new EventEmitter<CodiceFiscaleResult>();

  @Input()
  codiceFiscaleHelperData: CodiceFiscaleHelperData = {
    nome: null,
    cognome: null,
    sesso: null,
    dataDiNascita: null,
    codiceCatastale: null
  };

  @Input()
  hideCancelConfirmButtons: boolean = false;

  codiceFiscaleComuniDataSource: DataSource;

  readonly elementRef: ElementRef = inject(ElementRef);

  private readonly codiceFiscaleService = inject(CodiceFiscaleService);

  now: Date = new Date();

  constructor(
    @Optional()
    @Inject(POPUP_INJECT.REF)
    private popupRef: PopupRef<any> | undefined,
    @Optional()
    @Inject(POPUP_INJECT.DATA)
    public data: any | undefined
  ) {
    this.codiceFiscaleComuniDataSource = new DataSource({
      store: new ArrayStore({
        data: this.codiceFiscaleService.getListaComuniConCodiceCatastale()
      }),
      paginate: true,
      pageSize: 25
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.codiceFiscaleHelperData = {
        nome: this.data.nome,
        cognome: this.data.cognome,
        codiceCatastale: this.data.codiceCatastale,
        dataDiNascita: this.data.dataDiNascita,
        sesso: this.data.sesso
      };
    }
  }

  isTitleVisible(): boolean {
    return false;
  }

  getTitle(): string {
    return sntTranslate(marker("Calcolo Codice Fiscale"));
  }

  onFieldDataChanged(): void {
    try {
      if (!this.dxForm.instance.validate().isValid) {
        return;
      }

      const nome = this.codiceFiscaleHelperData.nome;
      const cognome = this.codiceFiscaleHelperData.cognome;
      const sesso = this.codiceFiscaleHelperData.sesso;

      const dataDiNascita = this.codiceFiscaleHelperData.dataDiNascita;
      const dataNascitaGG = dateUtil(dataDiNascita).get("date");
      const dataNascitaMM = dateUtil(dataDiNascita).get("month") + 1;
      const dataNascitaYY = dateUtil(dataDiNascita).get("year");
      const codiceCatastale = this.codiceFiscaleHelperData.codiceCatastale;

      const codiceFiscale = this.codiceFiscaleService.calcola(
        nome,
        cognome,
        sesso,
        dataNascitaGG,
        dataNascitaMM,
        dataNascitaYY,
        codiceCatastale
      );

      const nomeComuneDiNascita =
        this.codiceFiscaleService.getComuneByCodiceCatastale(
          this.codiceFiscaleHelperData.codiceCatastale!
        );

      const result = {
        nome,
        cognome,
        sesso,
        comuneDiNascita: nomeComuneDiNascita,
        codiceCatastale,
        dataDiNascita,
        codiceFiscale
      };

      this.result.emit(result);
    } catch (ex) {
      console.warn(ex);
    }
  }

  async onCancel(): Promise<void> {
    await this.popupRef?.close();
  }

  async onConfirm(): Promise<void> {
    try {
      if (!this.dxForm.instance.validate().isValid) {
        return;
      }

      const nome = this.codiceFiscaleHelperData.nome;
      const cognome = this.codiceFiscaleHelperData.cognome;
      const sesso = this.codiceFiscaleHelperData.sesso;

      const dataDiNascita = this.codiceFiscaleHelperData.dataDiNascita;
      const dataNascitaGG = dateUtil(dataDiNascita).get("date");
      const dataNascitaMM = dateUtil(dataDiNascita).get("month") + 1;
      const dataNascitaYY = dateUtil(dataDiNascita).get("year");
      const codiceCatastale = this.codiceFiscaleHelperData.codiceCatastale;

      const codiceFiscale = this.codiceFiscaleService.calcola(
        nome,
        cognome,
        sesso,
        dataNascitaGG,
        dataNascitaMM,
        dataNascitaYY,
        codiceCatastale
      );

      const nomeComuneDiNascita =
        this.codiceFiscaleService.getComuneByCodiceCatastale(
          this.codiceFiscaleHelperData.codiceCatastale!
        );

      const result = {
        nome,
        cognome,
        sesso,
        comuneDiNascita: nomeComuneDiNascita,
        codiceCatastale,
        dataDiNascita,
        codiceFiscale
      };

      await this.popupRef?.close(result);
    } catch (ex) {
      console.warn(ex);
    }
  }
}
